import auth from '@/services/auth.services.js';
import { checkOcultarCpa } from '@/utils/functions.js';

export const menuItemsSysa = () => [
  {
    title: 'Principal',
    icon: 'mdi-home',
    children: [
      {
        title: 'Home',
        path: '/home',
        roles: ['home']
      }
    ]
  },
  {
    title: 'Registers',
    icon: 'mdi-clipboard-edit-outline',
    children: [
      {
        title: 'Company',
        path: '/registers/company/list',
        roles: ['company'],
        requierdRoot: true
      },
      {
        title: 'Brand',
        path: '/registers/brand/list',
        roles: ['brand']
      },
      {
        title: 'Sub Brand',
        path: '/registers/subBrand/list',
        roles: ['subBrand']
      },
      {
        title: 'Reward',
        path: '/registers/reward/list',
        roles: ['reward']
      },
      {
        title: 'Reward Profile',
        path: '/registers/reward/profile/list',
        roles: ['rewardProfile']
      },
      {
        title: 'Users',
        path: '/registers/user/list',
        roles: ['user']
      }
    ]
  },
  {
    title: 'Advertising',
    icon: 'mdi-share-variant',
    children: [
      {
        title: 'Campaign',
        path: '/registers/campaign/list',
        roles: ['campaign']
      },
      {
        title: 'Affiliates',
        path: '/registers/affiliate/list',
        roles: ['affiliate']
      },
      {
        title: 'Actions (Links)',
        path: '/registers/action/list',
        roles: ['action']
      },
      {
        title: 'Partner Levels',
        path: '/registers/partnerLevel/list',
        roles: ['partnerLevel']
      }
    ]
  },
  {
    title: 'Financial',
    icon: 'mdi-currency-usd',
    children: [
      {
        title: 'Payment by Affiliate',
        path: '/financial/affiliate/payment',
        roles: ['paymentByAffiliate', 'financial']
      },
      {
        title: 'Entry by Affiliate',
        path: '/financial/entries',
        roles: ['entryByAffiliate']
      }
    ]
  },
  {
    title: 'Reports',
    icon: 'mdi-file-table-outline',
    children: [
      {
        title: 'Activity per Affiliate',
        path: '/reports/affiliate/activity',
        roles: ['activityPerAffiliate']
      },
      {
        title: 'Detail by Affiliate',
        path: '/reports/affiliate/detail'
      },
      {
        title: 'General Report',
        path: '/reports/general/v2'
      },
      {
        title: 'Partners Demonstrative',
        path: '/reports/partners'
      },
      {
        title: 'Lotto report',
        path: '/reports/lottery'
      },
      {
        title: 'CPA report',
        path: '/reports/cpa'
      }
    ]
  },
  {
    title: 'Management',
    icon: 'mdi-cog-outline',
    children: [
      {
        title: 'Log',
        path: '/management/sys_activity_log',
        roles: ['manager'],
        requierdRoot: true
      }
    ]
  }
];

export const getMenuItems = () => {
  const user = auth.getLoggedUser();
  const menuItems = menuItemsSysa();

  if (!user?.roles) return [];

  return menuItems.filter((item) => {
    const children = item.children.filter((child) => {
      if (child.path === '/reports/cpa' && checkOcultarCpa()) {
        return false;
      }

      if (child?.requierdRoot === true) {
        return user?.root === true;
      }
      return child.roles
        ? child.roles.every((role) => {
            return user.roles.includes(role);
          })
        : true;
    });

    item.children = children;

    return children.length ? true : false;
  });
};
